import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()(() => ({
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
    overflow: "hidden",
  },
  modalContainer: {
    width: "90%",
    maxWidth: 360,
    borderRadius: 12,
    overflow: "hidden",
    boxShadow: "0 25px 50px rgba(0, 0, 0, 0.3)",
    position: "relative",
  },
  modal: {
    position: "relative",
    backgroundColor: "#fff",
    overflow: "hidden",
    width: "100%",
    height: "auto",
    "&:hover $spotlight": {
      opacity: 1,
    },
  },
  spotlight: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    pointerEvents: "none",
    background:
      "radial-gradient(circle at 50% 50%, transparent 10%, rgba(0,0,0,0.05) 100%)",
    opacity: 0,
    transition: "opacity 0.5s",
    zIndex: 10,
  },
  cornerRibbon: {
    position: "absolute",
    top: 0,
    right: 0,
    width: 110,
    background: "#ff3e4d",
    color: "#fff",
    textAlign: "center",
    fontSize: 10,
    fontWeight: 600,
    lineHeight: "24px",
    letterSpacing: 1,
    transform: "rotate(45deg) translateY(-50px) translateX(50px)",
    transformOrigin: "top right",
    boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
    zIndex: 10,
  },
  modalHeader: {
    position: "relative",
    height: 150, // reduced from 220
    overflow: "hidden",
  },
  blurredBg: {
    position: "absolute",
    top: 10,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundImage:
      "url('https://images.unsplash.com/photo-1503376780353-7e6692767b70?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    filter: "blur(8px)",
    transform: "scale(1.1)",
  },

  /* Particles */
  particlesContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    overflow: "hidden",
    zIndex: 3,
  },
  particle: {
    position: "absolute",
    borderRadius: "50%",
    background: "#fff",
    opacity: 0.6,
    animationName: "$float",
    animationTimingFunction: "linear",
    animationIterationCount: "infinite",
  },
  "@keyframes float": {
    "0%": {
      transform: "translateY(100%) translateX(0)",
      opacity: 0,
    },
    "10%": {
      opacity: 0.8,
    },
    "90%": {
      opacity: 0.8,
    },
    "100%": {
      transform: "translateY(-100px) translateX(30px)",
      opacity: 0,
    },
  },
  lockContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 5,
  },
  lockCircle: {
    width: 80,
    height: 80,
    background: "rgba(255, 255, 255, 0.8)",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "0 0 0 rgba(255, 255, 255, 0.7)",
    animation: "$pulse 2s infinite",
  },
  "@keyframes pulse": {
    "0%": {
      boxShadow: "0 0 0 0 rgba(255, 255, 255, 0.7)",
    },
    "70%": {
      boxShadow: "0 0 0 20px rgba(255, 255, 255, 0)",
    },
    "100%": {
      boxShadow: "0 0 0 0 rgba(255, 255, 255, 0)",
    },
  },
  modalBody: {
    padding: "20px 20px",
    textAlign: "center",
    position: "relative",
    zIndex: 2,
  },
  modalTitle: {
    fontSize: 24,
    fontWeight: 700,
    color: "#333",
    margin: "0 0 10px",
    position: "relative",
    display: "inline-block",
  },
  titleHighlight: {
    position: "relative",
    color: "#ff3e4d",
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: 2,
      left: 0,
      width: "100%",
      height: 6,
      background: "rgba(255, 62, 77, 0.2)",
      zIndex: -1,
      transform: "skew(-15deg)",
    },
  },
  modalSubtitle: {
    fontSize: 14,
    color: "#666",
    margin: "0 0 20px",
    lineHeight: 1.4,
  },
  features: {
    display: "flex",
    flexDirection: "column",
    textAlign: "left",
    gap: 12,
    marginBottom: 20,
  },
  feature: {
    display: "flex",
    alignItems: "center",
    padding: "10px 16px",
    background: "#fff",
    borderRadius: 8,
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
    transition: "transform 0.3s, box-shadow 0.3s",
    "&:hover": {
      transform: "translateY(-3px) scale(1.02)",
      boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
    },
  },
  featureIcon: {
    width: 36, // from 40
    height: 36,
    borderRadius: "50%",
    background: "rgba(255, 62, 77, 0.1)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 12,
    color: "#ff3e4d",
  },
  featureContent: {
    flex: 1,
  },
  featureTitle: {
    fontWeight: 600,
    fontSize: 14,
    marginBottom: 2,
    color: "#333",
  },
  featureDesc: {
    fontSize: 12,
    color: "#666",
  },
  modalFooter: {
    padding: "0 25px 25px",
    textAlign: "center",
    position: "relative",
  },
  btnUpgrade: {
    width: "100%",
    background: "#ff3e4d",
    color: "#fff",
    border: "none",
    padding: "14px 0",
    borderRadius: 6,
    fontWeight: 600,
    fontSize: 15,
    cursor: "pointer",
    transition: "all 0.3s ease",
    position: "relative",
    overflow: "hidden",
    boxShadow: "0 4px 15px rgba(255, 62, 77, 0.35)",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 7px 20px rgba(255, 62, 77, 0.4)",
    },
  },
  btnRing: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    height: "100%",
    borderRadius: 6,
    border: "2px solid rgba(255, 255, 255, 0.3)",
    opacity: 0,
    "$btnUpgrade:hover &": {
      animation: "$ring 1.5s infinite",
    },
  },
  "@keyframes ring": {
    "0%": {
      width: "100%",
      height: "100%",
      opacity: 0.8,
    },
    "100%": {
      width: "150%",
      height: "170%",
      opacity: 0,
    },
  },
  btnCancel: {
    background: "transparent",
    color: "#666",
    border: "none",
    padding: "10px 0",
    marginTop: 10,
    fontWeight: 500,
    fontSize: 13,
    cursor: "pointer",
    transition: "all 0.3s ease",
    textDecoration: "underline",
    "&:hover": {
      color: "#333",
    },
  },
}));
